import { z } from 'zod/v4'

import { freshnessSchema, type Freshness } from './freshness.js'

/**
 * A READ of a screen that can fail on its own. The screen answers `loaded` with its data, or `failed` with the
 * freshness that says so (`state: 'failed'`), and the rest of the screen is still served: one region that times out
 * must not take the other six with it. It is not a permission region (`screenRegion`): nobody is refused anything, a
 * read broke. The variant is `loaded` and not `ready` on purpose: `ScreenComposition` treats a `ready` variant as a
 * region whose function returns the bare data and wraps it, and a section is built by the function itself. The composition runs each of them inside its own SAVEPOINT (`readSection`, backend).
 */
export function screenSection<T extends z.ZodType>(data: T) {
  return z.discriminatedUnion('state', [
    z.strictObject({ state: z.literal('loaded'), data }),
    z.strictObject({ state: z.literal('failed'), freshness: freshnessSchema }),
  ])
}

export type ScreenSection<T> =
  | { state: 'loaded'; data: T }
  | { state: 'failed'; freshness: Freshness }
